import { useDispatch, useSelector } from "react-redux";
import {
  selectCurrentStepIndex,
  selectCurrentSubstepIndex,
  selectAddMoreCoversFlowType,
  setCurrentStepIndex,
  setCurrentSubstepIndex,
  setAddMoreCoversFlowType,
} from "../redux/features/motorInsuranceAddMoreCoversFlowSlice";
import {
  ADD_MORE_COVERS_FLOW_TRAVEL,
  ADD_MORE_COVERS_TRAVEL_ENHANCE_YOUR_COVERAGE,
  ADD_MORE_COVERS_TRAVEL_REVIEW_AND_CONFIRM,
} from "../pages/travelInsurancePages/endorsements/addMoreCovers/data";

const useTravelAddMoreCoversFlow = () => {
  const dispatch = useDispatch();
  const flowType = useSelector(selectAddMoreCoversFlowType);
  const currentStepIndex = useSelector((state) =>
    selectCurrentStepIndex(state)
  );
  const currentSubstepIndex = useSelector((state) =>
    selectCurrentSubstepIndex(state)
  );

  console.log(flowType, currentStepIndex, currentSubstepIndex,"travel add more covers flow");
  const steps = travel_insurance_add_more_covers_flow[flowType] || [];
  const currentStep = steps[currentStepIndex] || {};
  const currentSubstep = currentStep.substeps
    ? currentStep.substeps[currentSubstepIndex]
    : "";

  const handleFlowChange = (type, currentStepIndex, currentSubstepIndex) => {
    dispatch(
      setAddMoreCoversFlowType({
        type,
        currentStepIndex,
        currentSubstepIndex,
      })
    );
  };

  const handleNextSubstep = () => {
    console.log("🔄 handleNextSubstep called");
    console.log("- currentStep:", currentStep);
    console.log("- currentStepIndex:", currentStepIndex);
    console.log("- currentSubstepIndex:", currentSubstepIndex);
    console.log("- substeps length:", currentStep.substeps?.length);
    console.log("- steps total:", steps.length);
    
    if (
      currentStep.substeps &&
      currentSubstepIndex < currentStep.substeps.length - 1
    ) {
      console.log("📈 Moving to next substep");
      dispatch(setCurrentSubstepIndex(currentSubstepIndex + 1));
    } else if (currentSubstepIndex === currentStep.substeps.length - 1) {
      console.log("📈 Moving to next step");
      handleNextStep();
    } else {
      console.log("⚠️ Cannot advance - no more steps");
    }
  };

  const handlePrevSubstep = () => {
    if (currentSubstepIndex > 0) {
      dispatch(setCurrentSubstepIndex(currentSubstepIndex - 1));
    } else {
      handlePrevStep();
    }
  };

  const handleNextStep = () => {
    console.log("🔄 handleNextStep called");
    console.log("- currentStepIndex:", currentStepIndex);
    console.log("- steps.length:", steps.length);
    
    if (currentStepIndex < steps.length - 1) {
      console.log("📈 Setting step index to:", currentStepIndex + 1);
      dispatch(setCurrentStepIndex(currentStepIndex + 1));
      // Also reset substep to 0 for the new step
      dispatch(setCurrentSubstepIndex(0));
    } else {
      console.log("⚠️ Cannot advance - already at last step");
    }
  };

  const handlePrevStep = () => {
    if (currentStepIndex > 0) {
      const currentStep = steps[currentStepIndex - 1] || {};
      const substepIndex = currentStep?.substeps?.length - 1;
      dispatch(setCurrentStepIndex(currentStepIndex - 1));
      dispatch(setCurrentSubstepIndex(substepIndex));
    }
  };

  return {
    handleFlowChange,
    handleNextSubstep,
    handlePrevSubstep,
    handleNextStep,
    handlePrevStep,
    flowType,
    steps,
    currentStep,
    currentStepIndex,
    currentSubstep,
    currentSubstepIndex,
  };
};

export default useTravelAddMoreCoversFlow;

export const travel_insurance_add_more_covers_flow = {
  [ADD_MORE_COVERS_FLOW_TRAVEL]: [
    {
      name: ADD_MORE_COVERS_TRAVEL_ENHANCE_YOUR_COVERAGE,
      substeps: [ADD_MORE_COVERS_TRAVEL_ENHANCE_YOUR_COVERAGE],
    },
    {
      name: ADD_MORE_COVERS_TRAVEL_REVIEW_AND_CONFIRM,
      substeps: [ADD_MORE_COVERS_TRAVEL_REVIEW_AND_CONFIRM],
    },
  ],
};